import { createEntityAdapter } from "@reduxjs/toolkit";

const selectProductId = product =>
  product?.id ??
  product?.productId ??
  product?.advertisement?.variantId ??
  String(product);

export const searchProductsAdapter = createEntityAdapter({
  selectId: selectProductId
});
